import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const userDepartment = {
  namespaced: true,

  state: () => ({
    loading: false,
    userDepartmentRegistrationSuccess: false,
    userDepartmentRegistrationFailure: false
  }),

  getters: {
    _loading: state => state.loading,
    _userDepartmentRegistrationSuccess: state =>
      state.userDepartmentRegistrationSuccess,
    _userDepartmentRegistrationFailure: state =>
      state.userDepartmentRegistrationFailure
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    UserDepartment_REGISTRATION_SUCCESS (state, value) {
      state.userDepartmentRegistrationSuccess = value
    },
    UserDepartment_REGISTRATION_FAILURE (state, value) {
      state.userDepartmentRegistrationFailure = value
    }
  },

  actions: {
    CreateUserDepartment ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/UserDepartment/CreateUserDepartment', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('UserDepartment_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('UserDepartment_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    RemoveUserDepartment ({ commit, rootState, dispatch }, XpressUserDepartmentId) {
      return new Promise((resolve, reject) => {
        commit('LOADING', true)
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .get(
            `/UserDepartment/RemoveUserDepartment?XpressUserDepartmentId=${XpressUserDepartmentId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetUserDepartment ({ rootState, commit, dispatch }, XpressUserDepartmentId) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get(
            `/UserDepartment/GetUserDepartment?XpressUserDepartmentId=${XpressUserDepartmentId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllUserByDepartment ({ rootState, commit, dispatch }, departmentId) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        // commit('LOADING', true)
        api
          .get(
            `/UserDepartment/GetAllUserByDepartment?departmentId=${departmentId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default userDepartment
